<template>
  <div class="ai-chat">
    <div ref="log" class="ai-chat__log">
      <div v-if="!list.length" class="ai-chat__empty">
        <p>Задайте вопрос так, как его задал бы покупатель.</p>

        <div class="ai-chat__hints">
          <button
            v-for="(hint, index) in hints"
            :key="index"
            class="ai-chat__hint"
            type="button"
            @click="onHint(hint)"
          >
            {{ hint }}
          </button>
        </div>
      </div>

      <div
        v-for="(message, index) in list"
        :key="index"
        class="ai-chat__message"
        :class="`ai-chat__message--${message.role}`"
      >
        <div class="ai-chat__bubble">{{ message.content }}</div>
      </div>

      <div
        v-if="isLoading"
        class="ai-chat__message ai-chat__message--assistant"
      >
        <div class="ai-chat__bubble ai-chat__bubble--typing">
          Агент печатает&hellip;
        </div>
      </div>
    </div>

    <form class="ai-chat__form" @submit.prevent="onSend">
      <textarea
        ref="input"
        v-model="text"
        class="ai-chat__input"
        rows="2"
        placeholder="Например: нужны передние колодки на Логан 2014"
        :disabled="isLoading"
        @keydown.enter.exact.prevent="onSend"
      ></textarea>

      <base-btn
        class="ai-chat__submit"
        tag="button"
        :loading="isLoading"
        :disabled="!text.trim()"
        @click="onSend"
      >
        Отправить
      </base-btn>
    </form>

    <footer class="ai-chat__footer">
      <span v-if="totalTokens" class="ai-chat__tokens">
        Потрачено токенов за диалог: {{ totalTokens }}
      </span>

      <button
        v-if="list.length"
        class="link-action"
        type="button"
        @click="onClear"
      >
        Очистить диалог
      </button>
    </footer>
  </div>
</template>

<script>
import BaseBtn from "@/components/shared/BaseBtn.vue";

export default {
  components: {
    BaseBtn,
  },
  data() {
    return {
      text: "",
      list: [],
      isLoading: false,
      totalTokens: 0,
      hints: [
        "Чем отличаются керамические и полуметаллические колодки?",
        "Нужен масляный фильтр на Kia Rio 2017, 1.6 бензин",
        "Как узнать, какой аккумулятор подойдёт моей машине?",
        "Сколько идёт доставка в Читу и как оплатить?",
      ],
    };
  },
  methods: {
    onHint(hint) {
      this.text = hint;
      this.onSend();
    },
    onSend() {
      const text = this.text.trim();
      if (!text || this.isLoading) return;

      this.list.push({ role: "user", content: text });
      this.text = "";
      this.isLoading = true;
      this.onScroll();

      this.$http
        .post("ai/chat/send", { messages: this.list })
        .then(({ data }) => {
          if (data.success) {
            this.list.push({ role: "assistant", content: data.message });
            this.totalTokens += data.usage.total_tokens || 0;
          } else {
            this.$toast.error(data.error || "Агент не смог ответить.");
          }

          this.isLoading = false;
          this.onScroll();
        })
        .catch((error) => {
          const status = error.response && error.response.status;

          this.$toast.error(
            status === 429
              ? "Слишком много запросов, попробуйте позже."
              : "Не удалось получить ответ агента."
          );

          this.isLoading = false;
        });
    },
    onClear() {
      this.list = [];
      this.totalTokens = 0;
    },
    onScroll() {
      this.$nextTick(() => {
        const log = this.$refs.log;
        if (log) log.scrollTop = log.scrollHeight;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ai-chat {
  border: 1px solid $grey-300;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  &__log {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    height: 460px;
    overflow-y: auto;
    padding: 1.2rem;
  }

  &__empty {
    color: $stone;
    margin: auto 0;
    text-align: center;
  }

  &__hints {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    justify-content: center;
    margin-top: 1rem;
  }

  &__hint {
    background: $grey-100;
    border: 1px solid $grey-300;
    border-radius: 16px;
    color: $body-color;
    cursor: pointer;
    font-size: 0.85rem;
    padding: 0.4rem 0.9rem;

    &:hover {
      border-color: $primary;
    }
  }

  &__message {
    display: flex;

    &--user {
      justify-content: flex-end;
    }
  }

  &__bubble {
    border-radius: 12px;
    max-width: 80%;
    padding: 0.7rem 1rem;
    white-space: pre-wrap;

    .ai-chat__message--user & {
      background: $primary;
      color: $white;
    }

    .ai-chat__message--assistant & {
      background: $grey-100;
    }

    &--typing {
      color: $stone;
    }
  }

  &__form {
    border-top: 1px solid $grey-300;
    display: grid;
    gap: 0.8rem;
    grid-template-columns: 1fr auto;
    padding: 1rem;
  }

  &__input {
    border: 1px solid $grey-300;
    border-radius: 6px;
    padding: $input-padding-y $input-padding-x;
    resize: vertical;

    &:focus {
      border-color: $primary;
      outline: none;
    }
  }

  &__submit {
    align-self: end;
  }

  &__footer {
    align-items: center;
    border-top: 1px solid $grey-300;
    color: $stone;
    display: flex;
    font-size: 0.85rem;
    justify-content: space-between;
    padding: 0.6rem 1rem;
  }
}
</style>
